<template>
  <div class="login-container" v-loading="loading">
    <div class="login-content">
      <div class="login_left_img">
        <img src="@/assets/login/login_left_img.png" class="img" alt />
      </div>
      <div class="login_right_form" v-loading="loading">
        <div class="login_logo_title">{{ systemTitle || '智慧应用管理平台' }}</div>

        <div class="tabs">
          <div class="tabs-item" :class="{ active: activeName === '1' }" @click="activeName = '1'">账号登录</div>
          <div class="tabs-item" :class="{ active: activeName === '2' }" @click="activeName = '2'">短信登录</div>
        </div>
        <el-form v-if="activeName === '1'" ref="loginForm" label-position="right" :model="loginForm" :rules="loginRules"
          class="login-form">
          <el-form-item prop="loginId" label="账号 :">
            <el-input v-model="loginForm.loginId" placeholder="请输入账号" type="text" class="input_form"
              @keydown.native.enter="submitForm('loginForm')" />
          </el-form-item>

          <el-form-item prop="password" label="密码 :">
            <el-input v-model="loginForm.password" type="password" class="input_form" placeholder="请输入密码"
              @keydown.native.enter="submitForm('loginForm')" />
          </el-form-item>
        </el-form>

        <el-form v-if="activeName === '2'" ref="loginForm2" label-position="right" :model="loginForm2"
          :rules="loginRules2" class="login-form">
          <el-form-item prop="mobile" label="手机号 :">
            <el-input v-model="loginForm2.mobile" placeholder="请输入账号" type="text" class="input_form" />
          </el-form-item>
          <!-- <el-form-item prop="verifyCode" label="图形验证码 :">
            <div class="code-box">
              <el-input v-model="verifyCode" type="text" class="input_form" placeholder="请输入验证码" />
              <img @click="updateVerifyCode" :src="codeImg" class="code-img" alt="" />
            </div>
          </el-form-item> -->
          <el-form-item prop="verifyCode" label="短信验证码 :">
            <div class="code-box">
              <el-input v-model="loginForm2.verifyCode" @keydown.native.enter="submitForm2" type="text"
                class="input_form" placeholder="请输入验证码" />
              <el-button class="code-img" :disabled="smsNum > 0" type="primary" @click="sendCode">{{ smsNum > 0 ?
                `${smsNum}s` : '发送验证码' }}</el-button>
            </div>
          </el-form-item>
        </el-form>

        <el-button v-if="activeName === '1'" type="primary" class="login_btn"
          @click="submitForm('loginForm')">登录</el-button>
        <el-button v-if="activeName === '2'" type="primary" class="login_btn" @click="submitForm2">登录</el-button>
      </div>
    </div>

    <footer class="footer">
      <!-- 1. 工信部ICP备案号（必填） -->
      <p>
        <a href="https://beian.miit.gov.cn/" target="_blank">
          苏ICP备2023007209号-11
        </a>
      </p>
      <!-- 2. 公安备案号（如有则加，可选） -->
      <!-- <p>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602000000" target="_blank">
          粤公网安备 44010602000000号
        </a>
      </p> -->
      <!-- 3. 可选：网站版权信息 -->
      <p>© 2026 长江粮油科技（江苏）控股集团有限公司 All Rights Reserved</p>
    </footer>

    <!-- 独立密码弹窗组件 -->
    <ModifyPassword :visible.sync="pwdDialogVisible" :old-password="loginForm.password" :user-id="userId" @success="toMenu" />
  </div>
</template>

<script>
import { validPhoneNumber } from '@/utils/validator.js'
import ModifyPassword from '@/components/ModifyPassword.vue'
export default {
  name: 'login',
  components: {
    ModifyPassword
  },
  data() {
    return {
      activeName: '1',
      loginForm: {
        loginId: '',
        password: '',
        verifyCode: ''
      },
      verifyCode: '',
      smsNum: 0,
      loginForm2: {
        mobile: '',
        verifyCode: ''
      },
      codeImg: this.$apis.common.getVerifyCode + '?time=' + Number(new Date()),
      loginRules: {
        loginId: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loginRules2: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
          { pattern: validPhoneNumber, message: '手机号格式错误' }
        ],
        verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },

      loading: false,
      userId: '',
      pwdDialogVisible: false
    }
  },
  computed: {
    isHomeUrl() {
      return this.$store.state.isHomeUrl
    },
    systemTitle() {
      return this.$store.state.systemTitle
    }
  },

  methods: {
    updateVerifyCode() {
      this.codeImg =
        this.$apis.common.getVerifyCode + '?time=' + Number(new Date())
    },
    sendCode() {
      if (!this.loginForm2.mobile) {
        this.$message({ type: 'warning', message: '请输入手机号' })
        return
      }
      const reg = /^1[3-9]\d{9}$/

      if (!reg.test(this.loginForm2.mobile)) {
        this.$message({ type: 'warning', message: '手机号格式错误' })
        return
      }
      this.$axios.get(this.$apis.common.smsCode, {
        mobile: this.loginForm2.mobile
      }).then(() => {
        this.smsNum = 60
        this._timer = setInterval(() => {
          this.smsNum--
          if (!this.smsNum) {
            clearInterval(this._timer)
          }
        }, 1000)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          this.$axios
            .post(this.$apis.common.login, this.loginForm)
            .then(res => {
              this.$store.commit('setToken', res.token)
              this.$store.commit('setUser', res.user)
              if (res.user.mobile && this.loginForm.password === res.user.mobile.slice(-6)) {
                this.pwdDialogVisible = true
                this.userId = res.user.userId
              } else {
                this.toMenu()
              }
            })
            .catch(() => {
              this.updateVerifyCode()
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
        }
      })
    },
    toMenu() {
      this.$store.dispatch('loadUserMenus').then(res => {
        console.log('获取到的菜单', res)
        const fisrtMenu = res[0]
        if (fisrtMenu) {
          if (fisrtMenu.childNode && fisrtMenu.childNode.length > 0) {
            if (fisrtMenu.childNode[0].childNode && fisrtMenu.childNode[0].childNode.length > 0) {
              this.$router.replace(fisrtMenu.childNode[0].childNode[0].url)
            } else {
              this.$router.replace(fisrtMenu.childNode[0].url)
            }
          } else {
            this.$router.replace(fisrtMenu.url)
          }
        } else {
          this.$router.replace('/system/menu')
          this.$message({ type: 'error', message: '您暂无菜单权限' })
        }
      })
    },
    submitForm2() {
      this.$refs.loginForm2.validate(valid => {
        if (valid) {
          this.loading = true
          this.$axios
            .post(this.$apis.common.smsLogin, this.loginForm2)
            .then(res => {
              this.$store.commit('setToken', res.token)
              this.$store.commit('setUser', res.user)
              this.$store.dispatch('loadUserMenus').then(res => {
                const fisrtMenu = res[0]
                if (fisrtMenu) {
                  if (fisrtMenu.childNode && fisrtMenu.childNode.length > 0) {
                    this.$router.replace(fisrtMenu.childNode[0].url)
                  } else {
                    this.$router.replace(fisrtMenu.url)
                  }
                } else {
                  this.$router.replace('/system/menu')
                  this.$message({ type: 'error', message: '您暂无菜单权限' })
                }
              })
            })
            .catch(() => {
              this.updateVerifyCode()
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 底部备案区样式 - 通用基础样式 */
.footer {
  position: fixed;
  bottom: 5px;
  width: 100%;
  padding: 20px 0;
  /* 浅灰色背景，可自定义 */
  text-align: center;
  /* 备案号居中显示 */
  font-size: 12px;
  /* 备案号建议用小字号 */
  color: #333;
  /* 灰色文字，符合常规视觉 */
  margin-top: 50px;
  /* 与上方内容拉开距离 */
}

/* 备案号链接样式优化 */
.footer a {
  color: #333;
  /* 链接颜色与文字一致 */
  text-decoration: none;
  /* 去掉默认下划线 */
}

.footer a:hover {
  color: #333;
  /* 鼠标悬浮加深颜色 */
  text-decoration: underline;
  /* 悬浮加下划线，提升交互性 */
}

.tabs {
  display: flex;
  margin-bottom: 15px;
  border-bottom: 2px solid #eee;

  .tabs-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    flex: 1;
    position: relative;
    cursor: pointer;

    &.active {
      &::before {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: $color-primary;
      }
    }

    span {
      font-size: 24px;
    }
  }
}

.login-container {
  width: 100%;
  height: 100vh;
  position: relative;
  width: 100%;
  min-width: 1200px;
  min-height: 500px;
  background: url("../../assets/login/login_page_bg.png") no-repeat left top;
  background-size: 100% 100%;

  .login-content {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -240px;
    margin-left: -437px;
    width: 875px;
    height: 480px;
    border-radius: 13px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    .login_left_img {
      width: 481px;
      height: 481px;

      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .login_right_form {
      flex: 1;
      width: 330px;
      padding: 70px 30px 0 30px;
      height: 100%;
      box-sizing: border-box;

      ::v-deep .login-form {
        .el-form-item__label {
          font-size: 14px;
          font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          width: 94px;
        }

        .el-form-item__content {
          flex: 1;
        }

        .el-form-item {
          margin-bottom: 25px;
          display: flex;
        }

        .input_form {
          height: 40px;

          .el-input__inner {
            height: 100%;
            line-height: 40px;
          }
        }
      }

      .code-box {
        position: relative;

        .code-img {
          width: 90px;
          height: 100%;
          position: absolute;
          right: 0;
          bottom: 0;
          top: 0;

          &.el-button {
            padding: 0;
          }
        }
      }

      .login_logo_title {
        font-size: 32px;
        font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-bottom: 50px;
      }

      .login_btn {
        width: 100%;
        height: 40px;
      }
    }
  }
}
</style>
